import { useEffect, useRef } from "react";
import { useUsers } from "modules/providers/users-provider";
import { useTags } from "modules/providers/tags-provider";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import { setMentionResolver } from "modules/quill/mentions/mention-registry";
import { MENTION_TYPE } from "modules/utils/Constants";

const useMentionResolver = () => {
  const { usersById } = useUsers();
  const { tagsById } = useTags();
  const { distributionGroupsById } = useDistributionGroups();

  const usersByIdRef = useRef(usersById);
  const tagsByIdRef = useRef(tagsById);
  const distributionGroupsByIdRef = useRef(distributionGroupsById);

  // Refs update synchronously during render, before any effects run
  usersByIdRef.current = usersById;
  tagsByIdRef.current = tagsById;
  distributionGroupsByIdRef.current = distributionGroupsById;

  useEffect(() => {
    setMentionResolver((id, type) => {
      switch (type) {
        case MENTION_TYPE.USER:
          return usersByIdRef.current[id] ?? null;
        case MENTION_TYPE.TAG:
          return tagsByIdRef.current[id] ?? null;
        case MENTION_TYPE.DISTRIBUTION_GROUP:
          return distributionGroupsByIdRef.current[id] ?? null;
        default:
          return null;
      }
    });
  }, []);
};

export default useMentionResolver;
